import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { assert } from '@sama/js-core';
import { find, isNil } from '@sama/micro-dash';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { getOutputHelper } from '../../../../shared/output-helpers/get-output-helper';
import { TextfieldOutputHelper } from '../../../../shared/output-helpers/textfield-output-helper';
import { TextfieldOutput } from '../../../../team-apis/otterdam/outputs/textfield-output';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

@Component({
  selector: 'h3-textfield-output',
  templateUrl: './textfield-output.component.html',
  styleUrls: ['./textfield-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextfieldOutputComponent
  extends AbstractNestableOutputComponent<TextfieldOutput>
  implements OnInit
{
  validationMessage = {
    invalidDictionaryValue: 'Please select an answer from the list',
  };
  protected filteredDictionaryTerms$?: Observable<string[] | undefined>;
  private dictionaryTerms?: string[];
  private dictionaryId?: number;

  override ngOnInit() {
    super.ngOnInit();
    this.setDictionaryTermsAndId();
    // needs to be called after setDictionaryTerms for the validator
    this.initValidatorForDictionary();
    this.setSubscriptionToInput();
  }

  override getUnsubmittableReason() {
    if (this.form.controls.input.hasError('invalidDictionaryValue')) {
      return this.validationMessage.invalidDictionaryValue;
    }
    return super.getUnsubmittableReason();
  }

  getOutputName() {
    return this.outputInfoStore.state().output.name;
  }

  private initValidatorForDictionary() {
    const output = this.getOutput();
    if (
      !isNil(this.dictionaryId) &&
      output.meta?.dictionary_strict &&
      this.dictionaryTerms
    ) {
      this.form.controls.input.addValidators(this.dictionaryTermsValidator());
      this.form.controls.input.updateValueAndValidity();
    }
  }

  private setSubscriptionToInput() {
    this.filteredDictionaryTerms$ = this.form.controls.input.valueChanges.pipe(
      startWith(this.form.controls.input.value),
      map((value) =>
        this.dictionaryTerms
          ?.filter((term) =>
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
            term.toLowerCase().includes(value?.toLowerCase() || ''),
          )
          .slice(0, 100),
      ),
    );
  }

  private dictionaryTermsValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputValue = control.value;
      if (
        inputValue.trim() === '' ||
        find(this.dictionaryTerms, (option) => option === inputValue)
      ) {
        return null;
      }
      return { invalidDictionaryValue: true };
    };
  }

  private setDictionaryTermsAndId() {
    const output = this.getOutput();
    const helper = getOutputHelper('TextfieldOutput');
    assert(
      helper instanceof TextfieldOutputHelper,
      'must be a TextfieldOutputHelper',
    );
    this.dictionaryTerms = helper.getDictionaryTerms(output);
    this.dictionaryId = helper.getDictionaryId(output);
  }

  private getOutput() {
    return this.outputInfoStore.state().output;
  }
}
